/* eslint-disable no-unused-vars */
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { BtnType, clearInitialUrlProps } from '@core';
import { ClientRegistration, RegistrationResponse } from '@model';
import { SpProgram } from '@session';
import { RegistrationService } from '@entity/entity-services/registration.service';
import { SpProgramService } from '@session/sp-program.service';
import { NavMenuService, NavMenuVm } from '@app/app-components/nav/nav-menu.service';
import { AuthHelper } from '@core/services/auth-services/auth-helper';
import { PasswordPolicy } from '@model/password/password-policy';
import { PasswordPolicyComponent } from './password-policy.component';
import { PasswordService } from '@entity/entity-services/password.service';
import { NgForm, NgModel } from '@angular/forms';

@Component({
  selector: 'sp-create-login',
  templateUrl: './create-login.component.html'
})
export class CreateLoginComponent implements OnInit {
  @ViewChild('form') form: NgForm;
  @ViewChild('feinInput') feinModel: NgModel;
  btn = BtnType;
  navmenuvm$: Observable<NavMenuVm>;
  vm: ClientRegistration;
  program: SpProgram;
  public Policy: PasswordPolicy;
  @ViewChild(PasswordPolicyComponent) policyComponent!: PasswordPolicyComponent;
  newPassword: string;
  reEnterPassword: string;
  isOldPassword: boolean;
  spForceFeedback = false;
  showPassword = false;
  showConfirmPassword = false;
  public Policy$: Observable<PasswordPolicy>;
  constructor(
    private registrationService: RegistrationService,
    private spProgramService: SpProgramService,
    navMenuService: NavMenuService,
    private authHelper: AuthHelper,
    private passwordService: PasswordService
  ) {
    this.navmenuvm$ = navMenuService.vm$;
    this.vm = { ...this.vm };
  }
  ngOnInit(): void {
    this.vm.isSuccess = true;

    const extraQueryParams = this.authHelper.getExtraQueryParams();
    if (extraQueryParams.email){
      console.log('Email Registration');
      this.vm.isEmailUser = true;
      this.vm.isEntityChange = false;
      this.vm.email = decodeURIComponent(extraQueryParams.email);
    } else if (extraQueryParams.entity_change) {
      console.log('Email Registration with Entity Change');
      this.vm.isEmailUser = true;
      this.vm.isEntityChange = true;
      this.vm.email = '';
    }
    else {
      console.log('Username Registration');
      this.vm.isEmailUser = false;
    }

    this.spProgramService.loadProgramFromCurrentLocationAndPartnerCode().subscribe((s) => {
      this.program = s;
      this.passwordService.getPolicy(this.program?.programCode).subscribe((s) => {
        this.Policy = s;
        console.log(this.Policy);
      });
    });
    window.scrollTo(0, 0);
  }

  get disabled() {
    return this.program?.programCode === null;
    //return false;
  }

  handlePassword($event: Event, isNewPass: boolean): void {
    const getEventValue = (event: Event): string => {
      const target = event.target as HTMLInputElement;
      return target.value;
    };

    this.isOldPassword = false;

    isNewPass
      ? (this.newPassword = getEventValue($event))
      : (this.reEnterPassword = getEventValue($event));
  }

  submitPassword() {
    return this.policyComponent.IsValid;
  }
  createAccount() {
    this.spForceFeedback = true;
    if (!this.form.valid || !this.policyComponent.IsValid) {
      return false; // don't save if form is invalid, or no user
    }

    const extraQueryParams = this.authHelper.getExtraQueryParams();
    const request: ClientRegistration = {
      ...this.vm,
      domainName: window.location.host,
      rKey: extraQueryParams.rkey,
    };

    if (this.vm.isEmailUser && this.vm.isEntityChange) {
      request.username = request.email;
    }

    this.registrationService
      .createClientAccount(request)
      .pipe()
      .subscribe((result: RegistrationResponse) => {
        if (result && result.isSuccess === true) {
          //redirect the user to redirect url page
          clearInitialUrlProps();
          window.location.href = result.redirectUrl;
        } else if (result && !result.isSuccess) {
          this.vm.isSuccess = false;
          this.vm.validationErrors = result.validationErrors;
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.vm.validationErrors.forEach((errorMsg) => {
            if (errorMsg.description === 'INVALID FEIN') {
              this.feinModel.control.setErrors({ invalidValues: true });
            }
          });
          this.vm.password = '';
          this.vm.confirmPassword = '';
        }
      });
  }
}
